<template>
<div>
  <v-dialog v-model="dialogcashout" persistent max-width="500">
    <v-card>
      <v-card-title class="primary white--text">Permintaan Tarik Dana (CashOut)</v-card-title>
      <v-card-text>
        <v-tabs  v-model="tab">
          <v-tab>Cashout</v-tab>
          <v-tab>Syarat & Ketentuan</v-tab>
          <v-tab-item>
            <div class="mt-4">
              <div class="mb-4"> Saldo saat ini: <h2>{{formatAngka(user.member.memberbalance)}}</h2></div>
              <div><v-text-field type="number" label="Jumlah Cashout"  v-model="jumlah" /></div>
<!--              <v-btn :disabled="jumlah<50000" @click="getMemberBanksCashout(jumlah)" :loading="loading" class="mt-4" elevation="0" color="accent">-->
<!--                <v-icon>lock</v-icon> Cek Bank-->
<!--              </v-btn>-->
              <div  v-if="jumlah>=100000" class="mt-0">
                <v-select
                    :loading="loading"
                    @click="cekbank"
                    label="Bank"
                    item-text="bankcode"
                    item-value="id"
                    v-model="bankid"
                    :items="bankavailablecashout.banks">
                <template slot='item' slot-scope='{ item }'>
                  {{ item.bankcode }} - {{ item.accountno }} {{ item.accountname }}
                </template>
                ></v-select>
              </div>
              <v-row v-if="bankavailablecashout.ready && control">
                <v-col cols="12" md="8">
                  <v-text-field  label="OTP"  v-model="otp" />
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn @click="getOtp" :loading="loading" class="mt-4" elevation="0" color="accent">
                    <v-icon>lock</v-icon> Minta OTP
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <SyaratCashout/>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn elevation="0" dark @click="tutup" color="red">Tutup</v-btn>
        <v-spacer/>
        <v-spacer/>
        <v-btn :disabled="!statusLanjut" elevation="0" @click="lanjut" color="primary">Lanjut</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SyaratCashout from '@/components/SyaratCashout'
import Utils from '@/plugins/utils'

export default {
  name: 'DialogCashOut',
  components: { SyaratCashout },
  data: () => ({
    tab: null,
    jumlah: 0,
    bankid: 0,
    otp: '',
    valid: false,
    otptimeout: 30,
    control: false
  }),
  watch: {
    jumlah: function (old) {
      if (old < 100000) {
        this.control = false
        this.cleardata()
      } else {
        this.control = true
      }
    }
  },
  computed: {
    ...mapState('SaldoStore', ['dialogcashout', 'memberbanks', 'otpkey', 'loading', 'bankavailablecashout']),
    ...mapState('authentication', ['user']),
    statusLanjut () {
      return this.bankavailablecashout.ready && this.otp.length > 4
    }
  },
  methods: {
    ...mapActions('SaldoStore', ['cleardata', 'setdialogcashout', 'doCashout', 'getOtp', 'getMemberBanksCashout']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    cekvalid () {
      return this.jumlah > 50000
    },
    tutup () {
      this.jumlah = 0
      this.otp = ''
      this.setdialogcashout(false)
    },
    lanjut () {
      this.doCashout({ id: this.bankid, amount: this.jumlah, key: this.otpkey, otp: this.otp })
      this.jumlah = 0
      this.otp = ''
      this.$ga.event({
        eventCategory: 'Balance',
        eventAction: 'CashOut',
        eventLabel: this.bankid,
        eventValue: this.jml
      })
    },
    cekbank () {
      console.log('cek bank')
      this.getMemberBanksCashout(this.jumlah)
    }
  }
}
</script>

<style scoped>

</style>
